import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Checkbox from 'components/ui/Checkbox';

import {
  CheckBoxWrapper,
  StyledTextInput,
  StyledDateOfBirthInput,
  DetailsItemContainer,
  AccountDetailsItemValue
} from '../ClubEurostarMember.styles';

const TYPE = {
  TEXT: 'text',
  INPUT: 'input',
  CHECKBOX: 'checkbox',
  DATE_INPUT: 'date-input'
};

const DetailsItem = ({ type = TYPE.TEXT, labelTranslationKey, value, dataTestid }) => (
  <DetailsItemContainer>
    {type === TYPE.CHECKBOX && (
      <CheckBoxWrapper>
        <Checkbox data-testid="checkbox-value" checked={value} onChange={() => {}} />
      </CheckBoxWrapper>
    )}
    <FormattedMessage id={labelTranslationKey} tagName="strong" />
    {type === TYPE.TEXT && <AccountDetailsItemValue data-testid={dataTestid || 'text-value'}>{value}</AccountDetailsItemValue>}
    {type === TYPE.INPUT && (
      <StyledTextInput data-testid={dataTestid || 'input-value'} name={labelTranslationKey} type="text" value={value} readOnly />
    )}
    {type === TYPE.DATE_INPUT && (
      <div>
        {value.split(' ').map((item) => (
          <StyledDateOfBirthInput key={item} data-testid={dataTestid || 'date-input-value'} type="text" value={item} readOnly />
        ))}
      </div>
    )}
  </DetailsItemContainer>
);

DetailsItem.propTypes = {
  labelTranslationKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  type: PropTypes.string,
  dataTestid: PropTypes.string
};

export default DetailsItem;
